import React, { useState } from "react";
import { Link } from "react-router-dom";
import { API } from "../lib/api";
import { toast } from "sonner";
import { Mail, ArrowRight, CheckCircle2 } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const r = await fetch(`${API}/member/forgot-password`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });
      const j = await r.json().catch(() => ({}));
      if (!r.ok) throw new Error(j.detail || "Failed");
      setSent(true);
    } catch (e) {
      toast.error(e.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0A0A0A] text-white grid place-items-center px-6" data-testid="forgot-password-page">
      <div className="w-full max-w-md border border-zinc-800 bg-[#141414] p-8 md:p-10">
        {sent ? (
          <>
            <CheckCircle2 size={40} className="text-[#E5B43A] mb-6" />
            <h1 className="font-display text-3xl mb-3">Check Your Inbox</h1>
            <p className="text-zinc-400 text-sm mb-6">
              If <b className="text-white">{email}</b> matches a Gain Time account,
              we've sent a reset link. It expires in 2 hours.
            </p>
            <Link to="/member/login" data-testid="back-to-login" className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-widest text-[#E5B43A] hover:underline">
              ← Back to sign in
            </Link>
          </>
        ) : (
          <form onSubmit={submit} data-testid="forgot-form">
            <div className="flex items-center gap-3 mb-8">
              <span className="w-10 h-10 bg-[#E5B43A] grid place-items-center">
                <Mail size={18} className="text-black" />
              </span>
              <div>
                <div className="text-[10px] tracking-[0.3em] uppercase text-zinc-500">Reset</div>
                <div className="font-display text-xl tracking-wider">Forgot Password</div>
              </div>
            </div>
            <p className="text-zinc-400 text-sm mb-6">Drop your member email — we'll send a secure reset link.</p>
            <label className="block text-[10px] tracking-[0.3em] uppercase text-zinc-500 mb-2">Email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              data-testid="forgot-email-input"
              className="w-full bg-[#0F0F0F] border border-zinc-800 px-4 py-3 mb-6 text-white focus:outline-none focus:border-[#E5B43A]"
            />
            <button
              type="submit"
              disabled={loading}
              data-testid="forgot-submit"
              className="w-full inline-flex items-center justify-center gap-3 bg-[#E5B43A] text-black font-bold uppercase tracking-widest px-6 py-4 text-sm hover:bg-white hover:text-[#0A0A0A] transition-colors disabled:opacity-60"
            >
              {loading ? "Sending..." : <>Send Reset Link <ArrowRight size={16} /></>}
            </button>
            <div className="mt-6 text-center text-xs">
              <Link to="/member/login" className="text-zinc-500 hover:text-[#E5B43A]">← Back to sign in</Link>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}
